import { useCallback } from 'react';
import { useAsyncRequest } from '../../../../hooks';
import { get } from '../../../../redux/api';
import type { ProjectGroupReleasesResponse } from '../../../../../typings/api';
import type { AsyncValue } from '../../../../redux/asyncValue';

export type FetchReleaseGroupReleasesQuery = {
  page: number;
  count: number;
  search?: string;
};

//  Function for actually fetching the releases.
const fetchReleases = (releaseGroupId: string, query: FetchReleaseGroupReleasesQuery) =>
  get<ProjectGroupReleasesResponse>(`/api/project_group/${releaseGroupId}/releases`, true, query);

/**
 * This is a hook which will fetch a paginated list of releases for
 * a given release group.
 */
const useReleases = (
  releaseGroupId: string,
  page: number,
  count: number,
  search?: string,
): AsyncValue<ProjectGroupReleasesResponse> => {
  //  This will recreate the callback if the releaseGroupId, page, count, or search changes.
  //  Changing the reference to this function causes useAsyncRequest to re-fetch.
  const request = useCallback(() => fetchReleases(releaseGroupId, { page, count, search }), [
    releaseGroupId,
    page,
    count,
    search,
  ]);
  return useAsyncRequest(request);
};

export default useReleases;
